import React, {
  useEffect,
  useState
} from "react"

import axios from "axios"
import Cookies from "js-cookie"

const API = "https://food-backend-9733.onrender.com"

const Profile = () => {
  const loginData = JSON.parse(
    Cookies.get("logincrd") || "{}"
  )

  const token = loginData?.token

  const [editMode, setEditMode] = useState(false)
  const [msg, setMsg] = useState("")
  const [user, setUser] = useState({
    name: "",
    email: "",
    phone: "",
    role: ""
  })

  useEffect(() => {
    if (!token) return

    axios.get(`${API}/profile`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    .then(res => {
      setUser(res.data)
    })
    .catch(err => {
      console.log(err)
      setMsg("Profile loading failed")
    })
  }, [token])

  const handleChange = (e) => {
    setUser({
      ...user,
      [e.target.name]: e.target.value
    })
    setMsg("")
  }

  const updateProfile = () => {
    axios.put(
      `${API}/profile`,
      user,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
    .then(res => {
      setMsg(res.data.msg)
      setEditMode(false)

      const oldData = JSON.parse(
        Cookies.get("logincrd") || "{}"
      )

      Cookies.set(
        "logincrd",
        JSON.stringify({
          ...oldData,
          user: {
            ...oldData.user,
            ...user
          }
        })
      )
    })
    .catch(err => {
      console.log(err)
      setMsg("Update failed")
    })
  }

  const initials = (user.name || "SV")
    .split(" ")
    .map(part => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase()

  return (
    <main className="profile-page">
      <section className="profile-hero">
        <div>
          <span>Account</span>
          <h1>Your Profile</h1>
          <p>
            Keep your delivery contact details updated for smoother orders.
          </p>
        </div>

        <div className="profile-avatar">
          {initials}
        </div>
      </section>

      <section className="profile-layout">
        <div className="profile-card">
          <div className="profile-card-head">
            <div>
              <h2>Personal Details</h2>
              <p>
                These details are used for order updates and delivery calls.
              </p>
            </div>

            <button
              type="button"
              className="profile-edit-btn"
              onClick={() => setEditMode(!editMode)}
            >
              {editMode ? "Cancel" : "Edit"}
            </button>
          </div>

          <div className="profile-form-grid">
            <label className="profile-field">
              <span>Name</span>
              <input
                type="text"
                name="name"
                value={user.name || ""}
                onChange={handleChange}
                disabled={!editMode}
              />
            </label>

            <label className="profile-field">
              <span>Email</span>
              <input
                type="email"
                name="email"
                value={user.email || ""}
                onChange={handleChange}
                disabled={!editMode}
              />
            </label>

            <label className="profile-field">
              <span>Phone</span>
              <input
                type="text"
                name="phone"
                value={user.phone || ""}
                onChange={handleChange}
                disabled={!editMode}
              />
            </label>

            <label className="profile-field">
              <span>Role</span>
              <input
                type="text"
                value={user.role || "customer"}
                disabled
              />
            </label>
          </div>

          {editMode && (
            <button
              type="button"
              className="profile-save-btn"
              onClick={updateProfile}
            >
              Save Changes
            </button>
          )}

          {msg && (
            <p className="profile-message">
              {msg}
            </p>
          )}
        </div>

        <aside className="profile-side-card">
          <h3>Account Benefits</h3>
          <p>Faster checkout with saved contact details.</p>
          <p>Live notifications for every order status.</p>
          <p>Custom food requirements connected to your account.</p>
        </aside>
      </section>
    </main>
  )
}

export default Profile
